"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetIcon = exports.ApWidgetIconTypes = void 0;
var React = require("react");
var styles_1 = require("./styles");
var ApWidgetIconTypes;
(function (ApWidgetIconTypes) {
    ApWidgetIconTypes["oxr"] = "oxr";
    ApWidgetIconTypes["sxr"] = "sxr";
    ApWidgetIconTypes["chc"] = "chc";
    ApWidgetIconTypes["txr"] = "txr";
    ApWidgetIconTypes["tsxr"] = "tsxr";
})(ApWidgetIconTypes = exports.ApWidgetIconTypes || (exports.ApWidgetIconTypes = {}));
exports.ApWidgetIcon = function (_a) {
    var type = _a.type, fontSize = _a.fontSize, color = _a.color;
    return (React.createElement(styles_1.Wrapper, { type: type, fontSize: fontSize, color: color }, type));
};
//# sourceMappingURL=ApWidgetIcon.js.map